import React from "react";

export default function ResearchSynopsis({ rootCount, pathwayCount, affords, constrains, supportTier }) {
  const dominant = affords > constrains ? "affording" : constrains > affords ? "constraining" : "mixed";
  return (
    <section className="rr-investigation-block rr-synopsis">
      <div className="rr-block-head">
        <div><span className="v25a-eyebrow">1 · WHAT IS HAPPENING HERE?</span><h4>Research synopsis</h4></div>
        <span className={`rr-support-badge ${supportTier.kind}`}>{supportTier.label}</span>
      </div>
      <p className="rr-synopsis-lead">
        {supportTier.kind === "single" ? <>
          A materialized relational explanation is present, but it currently rests on <b>one independent StudyRoot</b>. It is source-traceable, not multi-root convergence.
        </> : supportTier.kind === "multi" ? <>
          <b>{rootCount} independent StudyRoots</b> contribute across <b>{pathwayCount} materialized pathways</b>. The current topology is predominantly <b>{dominant}</b>.
        </> : <>
          A materialized explanation is present. Support depth is not classified strongly enough to call it single-root or multi-root.
        </>}
      </p>
      <div className="rr-synopsis-receipt"><span><b>{affords}</b> affords</span><span><b>{constrains}</b> constrains</span></div>
      <small className="rr-epistemic-note">Assembled from structured runtime receipts, not inferred from a capability or pathway label.</small>
    </section>
  );
}
